/* eslint-disable complexity, guard-for-in, max-lines, max-lines-per-function */
/* eslint-disable max-statements, no-negated-condition, vars-on-top */
/* eslint-env jquery */

import { GazeboBuilder } from './gazebo-builder';

export class GazeboBuilderClient extends GazeboBuilder {
    /**
     * Constructor.
     *
     * @param {NodeList} node The node to setup the builder on.
     */
    constructor(node) {
        super(node);
    }

    changeStep(stepId) {

        // if(stepId == "thanks"){
        //     window.location.href ="https://www.gazebo.com/build/thank-you/";
        //     return;
        // }

        $('.gb-tab-step').removeClass('current');
        $(`#gb-tab-step-${stepId}`).addClass('current');

        $('.gb-step').removeClass('current');
        $(`#gb-step-${stepId}`).addClass('current');

        $('.gb-mobile-menu-select-step').prop('selected', false);
        $(`#gb-mobile-menu-select-step-${stepId}`).prop('selected', true);

        $('.gb-form-error').remove();

        $('.gb-prev-next-link-container').remove();

        // Change to form step.
        if (this.isNumeric(stepId) === false) {
            this.stepId = stepId;

            // Move the page so tabs are visible.
            this.scrollToTop();

            this.replaceHistoryState();
            return;
        }

        this.stepId = Number(stepId);
        this.replaceHistoryState();

        const steps = this.buildSteps[this.o.conf.structure].steps;
        let lastStepId = 1;
        for (const i in steps) {
            lastStepId = i;
        }

        const prevStepId = this.stepId - 1;
        if (prevStepId >= 1) {
            this.prevNextWrapper.append(`
                <div class="gb-prev-next-link-container gb-direction-prev">
                    <a
                        id="gb-prev-next-step-${prevStepId}"
                        class="gb-prev-next-link"
                        href="#"
                    >
              <span class="gb-prev-next-step-icon">&nbsp;</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="prev-arrow">
                          <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <span class="gb-prev-next-direction">Back: </span>
                        <span class="gb-prev-next-step"> ${steps[prevStepId].name}</span>
                    </a>
                </div>
            `);
        }

        const nextStepId = this.stepId + 1;
        if (nextStepId <= lastStepId) {
            this.prevNextWrapper.append(`
                <div class="gb-prev-next-link-container gb-direction-next">
                    <a
                        id="gb-prev-next-step-${nextStepId}"
                        class="gb-prev-next-link"
                        href="#"
                    >
                        <span class="gb-prev-next-step-icon">&nbsp;</span>
                        <span class="gb-prev-next-direction">Next: </span>
                        <span class="gb-prev-next-step"> ${steps[nextStepId].name}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="next-arrow">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </a>
                </div>
            `);
        } else {
            this.prevNextWrapper.append(`
                <div class="gb-prev-next-link-container gb-direction-next">
                    <a
                        id="gb-prev-next-step-form"
                        class="gb-prev-next-link"
                        href="#"
                    >
                        <span class="gb-prev-next-step-icon">&nbsp;</span>
                        <span class="gb-prev-next-direction">Next: </span>
                        <span class="gb-prev-next-step">
                            <span class="less-important">Request</span> Quote
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="next-arrow">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                    </a>
                </div>
            `);
        }

        $('.gb-prev-next-link').click((e) => {
            e.preventDefault();
            const clickedStepId = $(e.currentTarget)
                .attr('id')
                .replace('gb-prev-next-step-', '');
            this.changeStep(clickedStepId);
        });
    }

    changeStructure() {
        $('.gb-form')
            .removeClass('gb-material-wood')
            .removeClass('gb-material-vinyl')
            .addClass(`gb-material-${this.o.conf.material}`);

        $('.gb-preview-bg').hide();
        $(`.gb-preview-bg--${this.o.conf.structure}`).show();

        const steps = this.buildSteps[this.o.conf.structure].steps;

        $('.gb-structure-header').html(
            this.buildSteps[this.o.conf.structure].name
        );

        let optionStep = 0;

        $(
            '.gb-tab-step, .gb-option-fields .gb-step, .gb-summary-step, .gb-mobile-menu-select-step'
        ).remove();

        for (const stepId in steps) {
            optionStep++;

            this.tabContainer.append(`
                <li
                    id="gb-tab-step-${stepId}"
                    class="gb-tab-step"
                >
                    <a
                        href="#gb-step-${stepId}"
                        title="${steps[stepId].name}"
                    >${steps[stepId].name}</a>
                </li>
            `);

            this.mobileTabContainer.append(`
                <option
                    id="gb-mobile-menu-select-step-${stepId}"
                    class="gb-mobile-menu-select-step"
                >${optionStep}&nbsp;&nbsp;&nbsp;&nbsp; ${steps[stepId].name}</option>
            `);

            this.fieldContainer.append(`
                <fieldset
                    id="gb-step-${stepId}"
                    class="gb-step"
                >
                    <legend class="gb-step-legend">${steps[stepId].name}</legend>
                </fieldset>
            `);

            this.summary.append(`
                <div
                    id="gb-summary-step-${stepId}"
                    class="gb-summary-step"
                >
                    <h3 class="gb-summary-step-header">${steps[stepId].name}</h3>
                </div>
            `);

            this.refreshStep(stepId);

            // Remove the step if no attributes were added.
            if ($(`#gb-step-${stepId} .gb-attr`).length === 0) {
                optionStep--;

                $(
                    `#gb-step-${stepId}, #gb-tab-step-${stepId}, #gb-summary-step-${stepId}`
                ).remove();
            }
        }

        const stepNumberLabel = optionStep + 1;
        this.mobileTabContainer.append(`
            <option
                id="gb-mobile-menu-select-step-form"
                class="gb-mobile-menu-select-step"
            >${stepNumberLabel}&nbsp;&nbsp;&nbsp;&nbsp; Quote</option>
        `);

        $('.gb-tab-step > a').click((e) => {
            e.preventDefault();
            const clickedStepId = $(e.currentTarget)
                .parent()
                .attr('id')
                .replace('gb-tab-step-', '');
            this.changeStep(clickedStepId);
        });

        $('.gb-mobile-menu-select').change((e) => {
            e.preventDefault();
            let clickedStepId = $(e.currentTarget)
                .find('option:selected')
                .attr('id');
            clickedStepId = clickedStepId.replace(
                'gb-mobile-menu-select-step-',
                ''
            );
            this.changeStep(clickedStepId);
            $(e.currentTarget).blur();
        });

        $('.gb-button-step').click((e) => {
            e.preventDefault();
            const clickedStepId = $(e.currentTarget)
                .attr('id')
                .replace('gb-button-step-', '');
            this.changeStep(clickedStepId);
        });

        const expandedThumbnails = (e) => {
            e.preventDefault();
            $(e.currentTarget)
                .closest('.gb-attr-field-container')
                .toggleClass('less');
        };

        // If there are more than 4 thumbnails display an expansion arrow.
        $('.gb-attr-tpl-thumbnails:not(#gb-attr-style)').each(
            (index, element) => {
                const thumbnails = $(element).find('.gb-attr-radio-container');
                const thumbnailCnt = thumbnails.length;

                let hideAdditionalThumbnails = false;

                // Usually thumbnails are hidden if there are more than 4.
                if (thumbnailCnt > 4) {
                    hideAdditionalThumbnails = true;
                }

                // Material wood colors should show all options.
                $(element)
                    .closest('fieldset')
                    .addClass(`gb-attr-tpl-thumbnails-${thumbnailCnt}`);
                if (
                    $(element)
                        .closest('fieldset')
                        .attr('id') === 'gb-attr-material_color'
                ) {
                    hideAdditionalThumbnails = false;
                }

                if (hideAdditionalThumbnails) {
                    $(element)
                        .find('.gb-attr-field-container')
                        .append(
                            '<div class="gb-expand-attr"><a href="javascript:void(0);"><span>Expand</span></a></div>'
                        );
                    $(element)
                        .find('.gb-expand-attr a')
                        .click(expandedThumbnails)
                        .click();
                }
            }
        );

        const thumbnailsData = JSON.parse($('#gb-package-body').attr('data-link-thumbnails'));
        let isValid = false;

        if (thumbnailsData) {
            thumbnailsData.forEach(imageUrl => {
                const mainUrl = `${this.o.urlBase}/gazebo_builder_assets/thumbnails/link-thumbnails/`;
                const relativePath = imageUrl.split(mainUrl)[1];

                if (
                    relativePath.includes(this.o.conf.material) &&
                    relativePath.includes(this.o.conf.structure)
                ) {
                    isValid = true;
                }
            });
        }

        if (isValid) {
            // Add the CSS style dynamically
            const style = `
                    <style>
                        @media (min-width: 800px) {
                          #gb-attr-style .gb-attr-field-container {
                                border-right: 2px solid white;
                            }
                        }
                    </style>
                `;
            $('head').append(style);

            const gbAttrLinks = $('<div class="gb-attr-links"></div>');
            $('#gb-attr-style').append(gbAttrLinks);

            thumbnailsData.forEach(imageUrl => {
                const mainUrl = `${this.o.urlBase}/gazebo_builder_assets/thumbnails/link-thumbnails/`;
                const relativePath = imageUrl.split(mainUrl)[1];

                if (
                    relativePath.includes(this.o.conf.material) &&
                    relativePath.includes(this.o.conf.structure)
                ) {
                    const parts = relativePath.substring(0, relativePath.lastIndexOf('.')).split('_');
                    const lastPart = parts[parts.length - 1];

                    const outerDiv = $('<div class="image-text-wrapper"></div>');

                    const imgElement = $('<img>').attr('src', `${mainUrl}${relativePath}`);

                    const imgWrapper = $('<div class="image-wrapper"></div>');

                    const innerDiv = $('<div class="inner-div"></div>');

                    // Extract the text after the last underscore '_'
                    const textAfterUnderscore = lastPart.split('.')[0];
                    let formattedText = textAfterUnderscore.replace(/-/g, ' '); // Replace hyphens with spaces

                    // Remove structure or material if found
                    if (formattedText.includes(this.o.conf.structure)) {
                        formattedText = formattedText.replace(this.o.conf.structure, '');
                    }

                    if (formattedText.includes(this.o.conf.material)) {
                        formattedText = formattedText.replace(this.o.conf.material, '');
                    }

                    // Capitalize the first letter of each part after splitting by ' '
                    formattedText = formattedText.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');

                    formattedText = formattedText.replace(/\bS\b/g, '').trim();

                    innerDiv.text(formattedText);

                    imgWrapper.append(imgElement);

                    outerDiv.append(imgWrapper);
                    outerDiv.append(innerDiv);

                    // Create the link with the specified href format
                    let linkUrl = `https://www.gazebo.com/${this.o.conf.structure}s/${parts[1]}/${parts[2]}`;

                    const companyId = $('input[name="company_id"]').val();

                    if (companyId && parseInt(companyId) !== 2) {
                        linkUrl += '?clg-content-only';
                    }

                    const linkElement = $('<a></a>')
                        .attr('href', linkUrl.toLowerCase()) // Lowercase the link URL
                        .attr('class', 'outer-image-text-wrapper')
                        .append(outerDiv);

                    if (companyId && parseInt(companyId) !== 2) {
                        linkElement.attr('target', '_self');
                    } else {
                        linkElement.attr('target', '_top');
                    }

                    gbAttrLinks.append(linkElement);
                }
            });
        }

        this.changeStep(this.stepId);
    }

    refreshStep(stepId) {
        const stepContainer = $(`#gb-step-${stepId}`);
        const summaryStepContainer = $(`#gb-summary-step-${stepId}`);

        const attrs = this.buildSteps[this.o.conf.structure].steps[stepId]
            .attrs;

        for (const attr in attrs) {
            let showThumbnails = false;
            if (
                typeof attrs[attr].thumbnails !== 'undefined' &&
                attrs[attr].thumbnails === true
            ) {
                showThumbnails = true;
            }

            let isCheckbox = false;
            if (
                typeof attrs[attr].checkbox !== 'undefined' &&
                attrs[attr].checkbox === true
            ) {
                isCheckbox = true;
            }

            const legend = attrs[attr].name;
            let attrTplClass = '';

            if (showThumbnails === true) {
                attrTplClass = ' gb-attr-tpl-thumbnails';
            }
            if (isCheckbox === true) {
                attrTplClass += ' gb-attr-checkbox';
            }

            // Add a fieldset and legend for each attribute.
            stepContainer.append(`
                <fieldset
                    id="gb-attr-${attr}"
                    class="gb-attr${attrTplClass}"
                >
                    <legend class="gb-attr-legend"><span>${legend}</span></legend>
                    <div class="gb-attr-field-container"></div>
                </fieldset>
            `);

            summaryStepContainer.append(`
                <div
                    id="gb-summary-attr-${attr}"
                    class="gb-summary-attr"
                >
                    <strong class="gb-summary-attr-header">${attrs[attr].name}: </strong>
                    <span data-stepid="${stepId}" class="gb-summary-attr-value"></span>
                </div>
            `);

            // Add fields for the attribute.
            this.refreshAttr(stepId, attr);

            // Remove the fieldset if no fields were added.
            if (
                $(`#gb-attr-${attr} > .gb-attr-field-container .gb-attr-field`)
                    .length === 0
            ) {
                $(`#gb-attr-${attr}, #gb-summary-attr-${attr}`).remove();
            }
        }
    }

    refreshAttr(stepId, attr) {
        let onOptionChange;

        let onMobileOptionChange;

        const attrContainer = $(`#gb-attr-${attr} > .gb-attr-field-container`);

        const attrs = this.getAttrConf(this.o.conf.structure, stepId, attr);

        const isBase = typeof attrs.base !== 'undefined' && attrs.base === true;

        const showPrice =
            typeof attrs.price !== 'undefined' && attrs.price === true;

        const showWidthLength =
            typeof attrs.width_length !== 'undefined' &&
            attrs.width_length === true;

        const showThumbnails =
            typeof attrs.thumbnails !== 'undefined' &&
            attrs.thumbnails === true;

        const showAllOptions =
            typeof attrs.show_all_options !== 'undefined' &&
            attrs.show_all_options === true;

        let defaultValue = [];
        if (typeof attrs.default_value !== 'undefined') {
            defaultValue = attrs.default_value;
        }

        let currentVal = this.getConfValue(attr);

        if (typeof attrs.qty !== 'undefined' && attrs.qty === true) {
            // Check if the option is available with the current configuration
            // before adding it.
            if (this.optionIsAvailable(stepId, attr) === true) {
                const numOfPosts = this.getNumberOfPosts();
                const numOfOutlets = this.getNumberOfOutlets();
                const numOfBenches = this.getNumberOfBenches();
                const numOfAdditionalPosts = this.getNumberOfAdditionalPosts();
                const numOfHigherPostIncrements = this.getNumberOfHigherPostIncrements();
                const numOfExtraScreenDoors = this.getNumberOfExtraScreenDoors();
                const numOfPrivacyPanels = this.getNumberOfPrivacyPanels();
                const numOfCanopies = 10;
                const numOfCurtains = 10;

                let minNum = '';
                let maxNum = '';
                let maxLength = '';
                let min = 0;
                let max = 0;
                if (typeof attrs.min !== 'undefined') {
                    min = attrs.min;
                    minNum = ` min="${min}" `;
                }
                if (typeof attrs.max !== 'undefined') {
                    if (attrs.max === 'number_of_posts') {
                        max = numOfPosts;
                    } else if (attrs.max === 'number_of_outlets') {
                        max = numOfOutlets;
                    } else if (attrs.max === 'number_of_benches') {
                        max = numOfBenches;
                    } else if (attrs.max === 'number_of_additional_posts') {
                        max = numOfAdditionalPosts;
                    } else if (
                        attrs.max === 'number_of_higher_post_increments'
                    ) {
                        max = numOfHigherPostIncrements;
                    } else if (attrs.max === 'number_of_extra_screen_doors') {
                        max = numOfExtraScreenDoors;
                    } else if (attrs.max === 'number_of_privacy_panels') {
                        max = numOfPrivacyPanels;
                    } else if (attrs.max === 'number_of_canopies') {
                        max = numOfCanopies;
                    } else if (attrs.max === 'number_of_curtains') {
                        max = numOfCurtains;
                    } else {
                        max = attrs.max;
                    }

                    maxLength = 1;
                    if (max > 9) {
                        maxLength = 2;
                    }

                    maxNum = ` max="${max}" `;
                }

                onOptionChange = (e) => {
                    // Update the conf array with the new value.
                    let val = $(e.currentTarget).val();
                    if (val === '') {
                        val = 0;
                    }
                    this.o.conf[attr] = val;

                    this.refreshConfId();
                    this.refreshConf();
                    this.changeStructure();
                    this.changeSize();
                    this.refreshWidthLength();
                    this.refreshImg();
                    this.refreshSummary();
                    this.replaceHistoryState();
                };

                let priceText = '';
                if (parseInt(this.o.userProfile.show_prices, 10) === 1) {
                    const attrOptionPrice = this.getOptionPrice(attr);
                    priceText = `<span class="gb-attr-price">$${attrOptionPrice} per unit</span>`;
                }

                // Use a select box for qty.
                if (
                    attrs.max === 'number_of_posts' ||
                    attrs.max === 'number_of_benches' ||
                    attrs.max === 'number_of_outlets' ||
                    attrs.max === 'number_of_additional_posts' ||
                    attrs.max === 'number_of_higher_post_increments' ||
                    attrs.max === 'number_of_extra_screen_doors' ||
                    attrs.max === 'number_of_privacy_panels' ||
                    attrs.max === 'number_of_canopies' ||
                    attrs.max === 'number_of_curtains'
                ) {
                    attrContainer.append(`
                        <div class="gb-attr-select-container gb-qty-select-container">
                            <select
                                name="${attr}"
                                id="gb-attr-${attr}-field"
                                class="gb-attr-field gb-attr-select-field"
                            ></select>
                            ${priceText}
                        </div>
                    `);
                    for (let qtyOption = min; qtyOption <= max; qtyOption++) {
                        $(`#gb-attr-${attr}-field`).append(`
                            <option
                                value="${qtyOption}"
                            >${qtyOption}</option>
                        `);
                    }
                } else {
                    // Add the option's quantity field.
                    attrContainer.append(`
                        <input
                            ${minNum}
                            ${maxNum}
                            ${maxLength}
                            type="number"
                            name="${attr}"
                            id="gb-attr-${attr}-field"
                            class="gb-attr-field gb-attr-qty-field"
                        />
                        ${priceText}
                    `);
                }

                if (currentVal === false) {
                    currentVal = 0;
                }

                $(`#gb-attr-${attr}-field`).val(currentVal);
                this.o.conf[attr] = currentVal;

                $(`#gb-attr-${attr}-field`).change(onOptionChange);
            }

            if ($(`[name="${attr}"]`).length === 0) {
                delete this.o.conf[attr];
            }
        } else if (typeof attrs.options !== 'undefined') {
            let mobileFieldAdded = false;

            onOptionChange = (e) => {
                // Update the conf array with the new value.
                const fieldName = $(e.currentTarget).attr('name');
                const newVal = $(`[name="${fieldName}"]:checked`).val();
                this.o.conf[fieldName] = newVal;

                $(`#gb-attr-${fieldName}-mobile-field`).val(newVal);

                // Vinylite Windows Can't be bought along side a screen package.
                if (fieldName === 'vinylite_windows' && newVal === 'yes') {
                    $('[name="screen_package"]').prop('checked', false);
                    $('#gb-attr-screen_package-mobile-field').val('no');
                    this.o.conf.screen_package = 'no';
                } else if (fieldName === 'screen_package' && newVal === 'yes') {
                    $('[name="vinylite_windows"]').prop('checked', false);
                    $('#gb-attr-vinylite_windows-mobile-field').val('no');
                    this.o.conf.vinylite_windows = 'no';
                }

                // Default the kit setup percentage to the value stored
                // in the yes field.
                if (fieldName === 'kit_setup' && newVal === 'yes') {
                    let defaultPercentage = 0;
                    if (
                        typeof this.buildOptions[this.confId].kit_setup__yes !==
                        'undefined' &&
                        this.buildOptions[this.confId].kit_setup__yes
                    ) {
                        defaultPercentage = this.buildOptions[this.confId]
                            .kit_setup__yes;
                    }
                    $('#gb-attr-kit_setup_percentage-mobile-field').val(
                        defaultPercentage
                    );
                    this.o.conf.kit_setup_percentage = defaultPercentage;
                }

                this.refreshConfId();
                this.refreshConf();
                this.changeStructure();
                this.changeSize();
                this.refreshWidthLength();
                this.refreshImg();
                this.refreshSummary();
                this.replaceHistoryState();
            };

            onMobileOptionChange = (e) => {
                // Pass the select mobile fields changes to the real fields.
                const id = $(e.currentTarget).attr('id');
                const val = $(e.currentTarget)
                    .find(':selected')
                    .val();
                const fieldName = id
                    .replace('gb-attr-', '')
                    .replace('-mobile-field', '');
                $(`#gb-attr-${fieldName}-field-${val}`)
                    .prop('checked', true)
                    .change();
            };

            const widths = [];

            // Add a radio button selection field.
            for (const option in attrs.options) {
                // Check if the option is available with the
                // current configuration before adding it.
                if (
                    this.optionIsAvailable(stepId, attr, option) === true ||
                    (isBase === true &&
                        (showAllOptions === true ||
                            this.confExists(attr, option) ||
                            (attr === 'style' &&
                                (this.confExists(
                                        attr,
                                        option,
                                        'size',
                                        'ft16x20'
                                    ) ||
                                    this.confExists(
                                        attr,
                                        option,
                                        'size',
                                        'ft20'
                                    ) ||
                                    this.confExists(
                                        attr,
                                        option,
                                        'size',
                                        'ft8x11'
                                    ) ||
                                    this.confExists(
                                        attr,
                                        option,
                                        'size',
                                        'ft8x8'
                                    )))))
                ) {
                    // Get the options price.
                    let price = 0;
                    if (isBase === true && showPrice === true) {
                        price = this.getOptionBasePrice(attr, option);
                    } else if (showPrice === true) {
                        price = this.getOptionPrice(attr, option);
                    }

                    let attrName = this.getOptionName(attrs, option);

                    if (
                        this.o.conf.material === 'wood' &&
                        this.o.conf.style === 'artisan' &&
                        attrName === '8x8'
                    ) {
                        attrName = '8x8 Cedar Wrapped';
                    }

                    // Format the price to display as part of the option label.
                    let priceStr = '';
                    let priceLabel = '';

                    if (
                        parseInt(this.o.userProfile.show_prices, 10) === 1 &&
                        price !== 0
                    ) {
                        priceStr = this.frmtMoney(price, 2, '.', ',');
                        if (price > 0 && isBase === false) {
                            priceStr = ` + ${priceStr}`;
                        }
                        priceStr = `$${priceStr}`;
                        priceStr = priceStr
                            .replace('$-', '- $')
                            .replace('$ + ', ' + $');
                        priceLabel = `<span class="gb-attr-price">${priceStr}</span>`;
                    }

                    let label = `${attrName}${priceLabel}`;
                    if (showWidthLength === true) {
                        // Keep track of widths and heights to allow the user to choose from.
                        const optionSizes = option.replace('ft', '').split('x');
                        if (typeof widths[optionSizes[0]] === 'undefined') {
                            widths[optionSizes[0]] = [];
                        }
                        if (optionSizes.length > 1) {
                            widths[optionSizes[0]].push(optionSizes[1]);
                        }
                    }
                    if (showThumbnails === true) {
                        let thumbnail = attrs.options[option].thumbnail.src;

                        let placeholderAttr;
                        for (placeholderAttr in this.o.conf) {
                            const placeholderAttrUpper = placeholderAttr.toUpperCase();
                            const placeholder = `[${placeholderAttrUpper}]`;
                            const placeholderVal = this.getConfValue(
                                placeholderAttr
                            );
                            thumbnail = thumbnail.replace(
                                placeholder,
                                placeholderVal
                            );
                        }

                        /* eslint-disable max-len */
                        label = `
                            <img
                                class="table-label-thumbnail"
                                src="${this.o.urlBase}/gazebo_builder_assets/thumbnails/${thumbnail}?v=${this.o.thumbnailVersion}"
                                alt=" ${attrName} Thumbnail"
                            />
                            <span class="table-label-attr">${label}</span>
                        `;
                        /* eslint-enable max-len */

                        if (
                            typeof attrs.options[option].description !==
                            'undefined' &&
                            attrs.options[option].description
                        ) {
                            label += `
                                <span
                                    class="table-label-description"
                                >${attrs.options[option].description}</span>
                            `;
                        }
                    }

                    // Add a mobile select box for the field.
                    if (mobileFieldAdded === false) {
                        mobileFieldAdded = true;
                        attrContainer.append(`
                            <div class="gb-attr-select-container gb-attr-mobile-select-container">
                                <select
                                    id="gb-attr-${attr}-mobile-field"
                                    class="gb-attr-field gb-attr-select-field gb-attr-mobile-select-field"
                                ></select>
                            </div>
                        `);

                        $(`#gb-attr-${attr}-mobile-field`).change(
                            onMobileOptionChange
                        );
                    }

                    // Add mobile select box option.
                    $(`#gb-attr-${attr}-mobile-field`).append(`
                        <option
                            value="${option}"
                        >${attrName}</option>
                    `);

                    // Add the option's radio button.
                    attrContainer.append(`
                        <div class="gb-attr-radio-container">
                            <input
                                type="radio"
                                name="${attr}"
                                id="gb-attr-${attr}-field-${option}"
                                class="gb-attr-field gb-attr-radio-field"
                                value="${option}"
                            />
                            <label
                                id="gb-attr-${attr}-${option}-label"
                                for="gb-attr-${attr}-field-${option}"
                                class="gb-attr-label gb-attr-radio-label"
                            >${label}</label>
                        </div>
                    `);

                    $(`#gb-attr-${attr}-field-${option}`).change(
                        onOptionChange
                    );
                }
            }

            if (showWidthLength === true) {
                let width;
                let height;

                attrContainer
                    .parent()
                    .prepend('<div class="gb-width-height-container"></div>');

                const widthHeightContainer = $('.gb-width-height-container');

                widthHeightContainer.append(`
                    <legend class="gb-attr-legend">
                        <span>Width</span>
                    </legend>
                    <div class="gb-size-selector-container gb-size-width-selector-container"></div>
                `);
                for (width in widths) {
                    if (
                        this.o.conf.structure === 'pavilion' &&
                        this.o.conf.style === 'grand_estate' &&
                        (Number(width) == 12 || Number(width) == 14)
                    ) {
                        /* eslint-disable-next-line no-continue */
                        continue;
                    }

                    if (
                        this.o.conf.structure === 'pavilion' &&
                        this.o.conf.style === 'alpine' &&
                        Number(width) == 20
                    ) {
                        /* eslint-disable-next-line no-continue */
                        continue;
                    }

                    widthHeightContainer.find(
                        '.gb-size-width-selector-container'
                    ).append(`
                            <div
                                class="gb-attr-radio-container gb-size-selector gb-size-width-selector"
                            >
                                <input
                                    type="radio"
                                    id="gb-unit-size-width-option-${width}"
                                    class="gb-unit-size-option gb-unit-size-width-option"
                                    name="unit-size-width"
                                    value="${width}"
                                />
                                <label
                                    id="gb-unit-size-width-option${width}-label"
                                    class="gb-unit-size-option-label gb-unit-size-width-option-label"
                                    for="gb-unit-size-width-option-${width}"
                                >${width}'</label>
                            </div>
                        `);
                }

                let addedHeightContainer = false;
                for (width in widths) {
                    if (
                        this.o.conf.structure === 'pavilion' &&
                        this.o.conf.style === 'grand_estate' &&
                        (Number(width) == 12 || Number(width) == 14)
                    ) {
                        /* eslint-disable-next-line no-continue */
                        continue;
                    }

                    if (
                        this.o.conf.structure === 'pavilion' &&
                        this.o.conf.style === 'alpine' &&
                        Number(width) == 20
                    ) {
                        /* eslint-disable-next-line no-continue */
                        continue;
                    }

                    for (height in widths[width]) {
                        const thisHeight = widths[width][height];

                        if (
                            this.o.conf.structure === 'pavilion' &&
                            this.o.conf.style === 'alpine' &&
                            ((Number(width) == 12 &&
                                    Number(thisHeight) == 10) ||
                                (Number(width) == 14 &&
                                    Number(thisHeight) == 10) ||
                                (Number(width) == 14 &&
                                    Number(thisHeight) == 12) ||
                                (Number(width) == 16 &&
                                    Number(thisHeight) == 10) ||
                                (Number(width) == 16 &&
                                    Number(thisHeight) == 12) ||
                                (Number(width) == 16 &&
                                    Number(thisHeight) == 14))
                        ) {
                            /* eslint-disable-next-line no-continue */
                            continue;
                        }

                        if (addedHeightContainer === false) {
                            widthHeightContainer.append(`
                                <legend class="gb-attr-legend">
                                    <span>Length</span>
                                </legend>
                                <div class="gb-size-selector-container gb-size-height-selector-container"></div>
                            `);

                            addedHeightContainer = true;
                        }

                        widthHeightContainer.find(
                            '.gb-size-height-selector-container'
                        ).append(`
                                <div
                                    class="
                                        gb-attr-radio-container
                                        gb-size-selector
                                        gb-size-height-selector
                                        gb-size-selector-choosen-width-${width}
                                    "
                                >
                                    <input
                                        type="radio"
                                        id="gb-unit-size-height-option-${width}-${thisHeight}"
                                        class="gb-unit-size-option gb-unit-size-height-option"
                                        name="unit-size-height"
                                        value="${thisHeight}"
                                    />
                                    <label
                                        id="gb-unit-size-height-option-${width}-${thisHeight}-label"
                                        class="gb-unit-size-option-label gb-unit-size-height-option-label"
                                        for="gb-unit-size-height-option-${width}-${thisHeight}"
                                    >${thisHeight}'</label>
                                </div>
                            `);
                    }
                }

                const onSizeChange = () => {
                    this.refreshWidthLength();

                    // If the size has changed update the real field.
                    const sizeWidth = $(
                        '.gb-size-width-selector > input:checked'
                    ).val();
                    let selectedSizeId = `#gb-attr-size-field-ft${sizeWidth}`;

                    const sizeHeight = $(
                        '.gb-size-height-selector > input:checked'
                    ).val();
                    if ($('.gb-size-height-selector').length !== 0) {
                        selectedSizeId += `x${sizeHeight}`;
                    }

                    if ($(selectedSizeId).prop('checked') === false) {
                        $(selectedSizeId)
                            .prop('checked', true)
                            .change();
                    }
                };

                $(
                    '.gb-size-width-selector > input, .gb-size-height-selector > input'
                ).change(onSizeChange);
            }

            if (attrContainer.parent().hasClass('gb-attr-checkbox')) {
                const checkboxLabel = attrContainer
                    .parent()
                    .find('.gb-attr-legend span')
                    .text();
                const noCheckbox = attrContainer
                    .find('.gb-attr-radio-container')
                    .first();
                const yesCheckbox = noCheckbox.next();
                yesCheckbox.find('.table-label-attr').text(checkboxLabel);
                noCheckbox.find('.table-label-attr').text(checkboxLabel);
            }

            if ($(`[name="${attr}"]`).length !== 0) {
                // Restore the current value.
                $(`#gb-attr-${attr}-field-${currentVal}`).prop('checked', true);
                $(`#gb-attr-${attr}-mobile-field`).val(currentVal);
                this.o.conf[attr] = currentVal;

                // If no value is set use the first in the list.
                if ($(`[name="${attr}"]:checked`).length === 0) {
                    if (
                        typeof defaultValue[0] !== 'undefined' &&
                        $(`[name="${attr}"][value="${defaultValue[0]}"]`)
                            .length !== 0
                    ) {
                        $(`[name="${attr}"][value="${defaultValue[0]}"]`).prop(
                            'checked',
                            true
                        );
                    } else if (
                        typeof defaultValue[1] !== 'undefined' &&
                        $(`[name="${attr}"][value="${defaultValue[1]}"`)
                            .length !== 0
                    ) {
                        $(`[name="${attr}"][value="${defaultValue[1]}"]`).prop(
                            'checked',
                            true
                        );
                    } else {
                        $(`[name="${attr}"]`)
                            .first()
                            .prop('checked', true);
                    }

                    const firstVal = $(`[name="${attr}"]:checked`).val();
                    $(`#gb-attr-${attr}-mobile-field`).val(firstVal);
                    this.o.conf[attr] = firstVal;
                }
            } else {
                delete this.o.conf[attr];
            }

            $(document).ready(function () {
                const checkedSizeValue = $('input[name="unit-size-width"]:checked').val();
                const checkedStructureValue = $('input[name="structure"]:checked').val();
                const checkedShapeValue = $('input[name="style"]:checked').val();
                const checkedMaterialValue = $('input[name="material"]:checked').val();
                const elementToRemove = document.querySelector('#gb-attr-turned_posts');

                const checkedRoofMaterial = $('input[name="roof_material"]:checked').val();
                const checkedColor = $('input[name="material_finish"]:checked').val();

                function addColorNotification(targetElement) {
                    const newElement = $('<div class="color-notification">New Colors Available</div>');

                    newElement.css({
                        'color': '#fff',
                        'margin-top': '20px'
                    });

                    if (targetElement.find('div.color-notification').length === 0) {
                        targetElement.append(newElement);
                    }
                }

                if (checkedStructureValue === 'gazebo') {
                    if (checkedRoofMaterial === 'metal_standing_seam' || checkedRoofMaterial === 'metal_regular_ribbed') {
                        addColorNotification($('#gb-attr-roof_color'));
                    }

                    if (checkedMaterialValue === 'wood' && checkedColor === 'stained') {
                        addColorNotification($('#gb-attr-material_color'));
                    }
                }

                if (
                    checkedStructureValue === 'gazebo' &&
                    checkedMaterialValue === 'vinyl' &&
                    checkedSizeValue &&
                    elementToRemove
                ) {
                    if (
                        (checkedShapeValue === 'octagon' &&
                            ['16', '18', '20'].includes(checkedSizeValue)) ||
                        (checkedShapeValue === 'dodecagon' &&
                            ['20', '22', '24', '26', '28', '30'].includes(
                                checkedSizeValue
                            ))
                    ) {
                        elementToRemove.remove();

                        const fieldsetElements = $('#gb-step-8').find('fieldset');

                        if (checkedShapeValue === 'dodecagon' && checkedMaterialValue === 'vinyl') {
                            if (fieldsetElements.length === 2) {
                                const fieldsetToModify = fieldsetElements.eq(1);

                                function updateStyle() {
                                    if ($(window).width() >= 801) {
                                        fieldsetToModify.addClass('move');
                                        fieldsetToModify.css('margin-left', '20.58333%');
                                    } else {
                                        fieldsetToModify.removeClass('move');
                                        fieldsetToModify.css('margin-left', '');
                                    }
                                }
                                // Initial setup
                                updateStyle();

                                $(window).resize(updateStyle);
                            }
                        }
                    }
                }
            });
        }
    }
}
